/**
 * Haptic feedback wrappers. All are no-ops when the Telegram WebApp is
 * unavailable (dev browser), so call-sites never need defensive checks.
 *
 * These match the HapticFeedback surface documented at
 * https://core.telegram.org/bots/webapps#hapticfeedback
 */

function hf(): TelegramWebAppHapticFeedback | undefined {
  return window.Telegram?.WebApp?.HapticFeedback;
}

export const haptics = {
  light(): void {
    hf()?.impactOccurred('light');
  },
  medium(): void {
    hf()?.impactOccurred('medium');
  },
  heavy(): void {
    hf()?.impactOccurred('heavy');
  },
  soft(): void {
    hf()?.impactOccurred('soft');
  },
  rigid(): void {
    hf()?.impactOccurred('rigid');
  },
  success(): void {
    hf()?.notificationOccurred('success');
  },
  warning(): void {
    hf()?.notificationOccurred('warning');
  },
  error(): void {
    hf()?.notificationOccurred('error');
  },
  selectionChanged(): void {
    hf()?.selectionChanged();
  },
};
